var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "proposal-viewer" }, [
    _vm.proposal
      ? _c("div", { staticClass: "proposal-toolbar d-print-none" }, [
          _c("div", { staticClass: "proposal-toolbar__identity" }, [
            _c(
              "span",
              { staticClass: "proposal-toolbar__icon" },
              [_c("portal-icon", { attrs: { name: "file-check", size: 20 } })],
              1
            ),
            _c("span", { staticClass: "proposal-toolbar__title" }, [
              _vm._v(_vm._s(_vm.proposal.coverPage.heading))
            ])
          ]),
          _c(
            "div",
            { staticClass: "proposal-toolbar__actions" },
            [
              _vm.proposal
                ? _c("comments-menu", {
                    attrs: {
                      comments: _vm.proposal.comments,
                      "proposal-id": _vm.proposal.id,
                      "client-id": _vm.proposal.clientId,
                      "proposal-service": _vm.proposalService,
                      "client-mode": true,
                      "viewed-timestamps": _vm.proposal.viewedTimestamps
                    }
                  })
                : _vm._e(),
              _vm.$vuetify.breakpoint.smAndUp
                ? _c(
                    "button",
                    {
                      staticClass: "proposal-toolbar__button",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.print()
                        }
                      }
                    },
                    [
                      _c("portal-icon", {
                        attrs: { name: "printer", size: 18 }
                      }),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("proposals.print-save-pdf")))
                      ])
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass:
                    "proposal-toolbar__button proposal-toolbar__language"
                },
                [
                  _c("language-switcher", {
                    attrs: {
                      label: _vm.$t("settings.language"),
                      children: _vm.countries.getCountriesTranslate(),
                      icon: "translate"
                    },
                    on: {
                      selected: function($event) {
                        return _vm.switchLocale($event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      : _vm._e(),
    !_vm.isReady
      ? _c(
          "div",
          { staticClass: "proposal-loading" },
          [
            _c("v-progress-circular", {
              attrs: { indeterminate: "", color: "primary", size: 34, width: 3 }
            })
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "proposal-document" },
          [
            _c("proposal-renderer", {
              attrs: {
                proposal: _vm.proposal,
                account: _vm.account,
                "proposal-service": _vm.proposalService,
                "edit-mode": false,
                "pod-service": null,
                "client-service": null,
                "need-save": false,
                saving: false,
                "client-mode": true,
                "is-locked": _vm.isLocked,
                "card-payment-failed": _vm.cardPaymentFailed
              },
              on: {
                "deliverable-selected": function($event) {
                  return _vm.deliverableSelected($event)
                },
                "client-signed": function($event) {
                  return _vm.clientFinalized($event)
                },
                "client-accepted": function($event) {
                  return _vm.clientFinalized($event)
                }
              }
            })
          ],
          1
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }